import { render, staticRenderFns } from "./remindList.vue?vue&type=template&id=c9403cba&scoped=true&"
import script from "./remindList.vue?vue&type=script&lang=js&"
export * from "./remindList.vue?vue&type=script&lang=js&"
import style0 from "./remindList.vue?vue&type=style&index=0&id=c9403cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9403cba",
  null
  
)

export default component.exports